// extracted by mini-css-extract-plugin
export default {"body":"menu_body__syOs6","main":"menu_main__+EIED","footer":"menu_footer__49JxE"};